import { Center } from "@chakra-ui/react"
import Alert from "@pathwright/ui/src/components/alert/Alert"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import { OrderFragment } from "@pathwright/graphql-client/src/generated"
import useOrderPollingQuery, {
  OnOrderFulfilledCallback,
  useOnOrderFullfiled
} from "./useOrderPollingQuery"

// Probably should move these fulfilled types/assertions to a more central location.
type OrderFragmentFulfilled = OrderFragment & { fulfilled_object_id: number }

function isOrderFulfilled(
  order: OrderFragment | null | undefined
): order is OrderFragmentFulfilled {
  if (!order) return false
  return order.order_status === "fulfilled" && !!order.fulfilled_object_id
}

// A shared loading node for the OrderProcessing component and its children.
export function OrderProcessingLoading() {
  return (
    <BlankSlate
      icons={null}
      heading="Processing order..."
      primaryAction={{
        brand: false,
        submitting: true
      }}
    />
  )
}

type OrderProcessingProps = {
  orderId: number
  onOrderFulfilled?: OnOrderFulfilledCallback
  children: (props: { order: OrderFragmentFulfilled }) => React.ReactNode
}

const OrderProcessing = ({
  orderId,
  onOrderFulfilled,
  children
}: OrderProcessingProps) => {
  const orderQuery = useOrderPollingQuery(orderId)
  const order = orderQuery.data && orderQuery.data.order

  useOnOrderFullfiled({
    order,
    onOrderFulfilled
  })

  return orderQuery.error ? (
    <Center>
      <Alert error={orderQuery.error} />
    </Center>
  ) : isOrderFulfilled(order) ? (
    children({ order })
  ) : (
    <OrderProcessingLoading />
  )
}

export default OrderProcessing
